module.exports = __webpack_public_path__ + "static/media/spaghet.4acca105.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catbot/spaghet.png
// module id = 149
// module chunks = 0